import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LanguageContext } from '../components/LanguageContext';
import axios from 'axios';

const Login = () => {
  const { language } = useContext(LanguageContext);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const savedNotification = localStorage.getItem("notification");
    if (savedNotification) {
      const { message, description } = JSON.parse(savedNotification);
      setError(`${message}: ${description}`);
      localStorage.removeItem("notification");
    }
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await axios.post(
        '/api/login',
        formData,
        {
          headers: {
            'X-CSRFToken': window.CSRF_TOKEN || '',
          },
          withCredentials: true,
          skipInterceptor: true,
        }
      );

      const { token, role } = response.data;

      localStorage.setItem('authToken', token);

      if (role === 'admin') {
        navigate('/admin-dashboard');
      } else {
        setError(language === 'en' 
          ? 'You do not have access to this section.' 
          : 'آپ کو اس سیکشن تک رسائی حاصل نہیں ہے۔');
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        setError(err.response.data.error);
      } else {
        setError(language === 'en' 
          ? 'An unexpected error occurred. Please refresh and try again.' 
          : 'ایک غیر متوقع غلطی واقع ہوئی۔ براہ کرم تازہ کریں اور دوبارہ کوشش کریں۔');
      }
    }
  };

  return (
    <div className={`min-h-screen bg-gray-50 mt-16 py-12 ${language === 'ur' ? 'rtl' : 'ltr'}`}>
      <div className="container mx-auto px-8">
        <div className="max-w-md mx-auto bg-white rounded-lg shadow-lg overflow-hidden">
          <div className="bg-blue-800 px-6 py-6">
            <h2 className={`text-2xl font-bold text-center text-white ${language === 'ur' ? 'text-right' : 'text-left'}`}>
              {language === 'en' ? "LOGIN" : "لاگ ان"}
            </h2>
          </div>

          <form onSubmit={handleSubmit} className="px-6 py-8">
            {error && (
              <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                {error}
              </div>
            )}

            <div className="mb-6">
              <label 
                htmlFor="email" 
                className={`block text-gray-700 font-medium mb-2 ${language === 'ur' ? 'text-right' : 'text-left'}`}
              >
                {language === 'en' ? "Email" : "ای میل"}
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>

            <div className="mb-6">
              <label 
                htmlFor="password" 
                className={`block text-gray-700 font-medium mb-2 ${language === 'ur' ? 'text-right' : 'text-left'}`}
              >
                {language === 'en' ? "Password" : "پاس ورڈ"}
              </label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                >
                  {showPassword ? '🙈' : '👁️'}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="w-full bg-blue-800 hover:bg-blue-900 text-white font-medium py-3 rounded-md transition-colors"
            >
              {language === 'en' ? "Login" : "لاگ ان"}
            </button>

          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
